import React from 'react'

const Error = () => {
  return (
    <div>
      This page does not exist
    </div>
  )
}

export default Error
